import { head_table } from "./inventory.constants";

import Th from "@/components/Table/Th";

const InventoryHead = ({ base, setBase }) => {
	return (
		<thead>
			<tr>
				{head_table.map((item, i) => {
					return (
						<Th
							key={i}
							item_name={item.name}
							item_size={item.size}
							item_order={item.order}
							order={base.order}
							orderType={base.orderType}
							setOrder={(value) => {
								setBase({ ...base, order: value });
							}}
							setOrderType={(value) => setBase({ ...base, order: item.order, orderType: value })}
							item_class={item.class}
							item_check_permission={item.check_permission}
						/>
					);
				})}
			</tr>
		</thead>
	);
};

export default InventoryHead;
